import { createContext, useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { userLogout } from 'utils/APIs';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [cookie, setCookie, removeCookie] = useCookies(['user']);
    const navigate = useNavigate();

    // call this function when you want to authenticate the user
    const login = (data) => {
        const { first_name = '', last_name = '', role = '', auth = '', DOB = '', email = '', gender = '', id = '', isEmailVerified = false } = data
        const userDetails = {
            first_name,
            last_name,
            role,
            auth,
            DOB,
            email,
            gender,
            id,
            isEmailVerified   
        }
        setCookie('user', userDetails, { path: '/' });
        if (data?.role === 'admin') {
            toast.success('Login successfully!');
            navigate('/');
         }
        else {
            toast.error('You are not authenticated for further actions');
        }
    };

    // call this function to sign out logged in user
    const logout = async () => {
        const formData = JSON.stringify({
            refreshToken: localStorage.getItem('refreshToken')
        });
        setCookie('user', null, { path: '/' });
        removeCookie('user', { path: '/' });
        await userLogout(formData).then(() => {
            toast.success('session is destroyed, You are logged out');
            navigate('/', { replace: true });
        });
    };

    const value = useMemo(
        () => ({
            cookie,
            login,
            logout
        }),
        [cookie]
    );
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};
